module.exports = __webpack_public_path__ + "img/145.03c6d1ff.jpg";